define(['backbone', 'assets/js/modules/backboneExtensions/backboneExtensions'], function(backbone, backboneExtensions) {
    backbone.logger = {
        info: function() {}
    };

    backbone.logger.error = backbone.logger.info;
    backbone.logger.log = backbone.logger.info;
    backbone.logger.warn = backbone.logger.info;

    backboneExtensions.inject(backbone);

    return backbone;
});
